export default __webpack_public_path__ + "static/media/EmployeeDirectory.4dc07f7b.PNG";